import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import IcX from "../../components/Svg/IcX";
import styles from "./style.module.css";
import Slct from "../Slct";
import Button from "../Button";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";
import { toast } from "react-toastify";

const ModalResourceTemplate = props => {
  const { show, closeModal, templates, addTemplate } = props;
  const { config } = useWrapper();

  const [template, settemplate] = useState();
  const [loading, setloading] = useState();

  return (
    <Modal size="md" show={show} onHide={closeModal} centered>
      <Modal.Header>
        <div as="label" className="d-flex w-100">
          <h2 className="page-title">Selecione o modelo de Orçamento</h2>
        </div>
        <button className={styles.closeModal} onClick={closeModal}>
          <IcX />
        </button>
      </Modal.Header>
      <Modal.Body>
        <Slct
          options={templates || []}
          value={template}
          onChange={__ev => {
            settemplate(__ev.value);
          }}
          className="w-100"
          placeholder="..."
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={async () => {
            setloading(true);
            try {
              const { data: _template_load } = await api.get(`template-business/${template}`, config);
              addTemplate(_template_load);
              toast.success("Modelo de Orçamento carregado com sucesso!");
            } catch (__err) {
              console.log("__err", __err);
              toast.error("Problemas ao carregar Modelo de Orçamento!");
            }
            setloading(false);
            settemplate(null);
            closeModal();
          }}
          loading={loading}
        >
          Carregar Modelo
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalResourceTemplate;
